import {tacticalPlanRuleCurrent, tacticalPlanStore} from "../../../stores/store";
import {get} from "svelte/store";

export function waitForZoneSave(handler: Function) {
    console.log('TacticalPlanRuleOne, waitForZoneSave, triggerStartSaveThisRuleByInnerId', get(tacticalPlanStore).triggerStartSaveThisRuleByInnerId, get(tacticalPlanRuleCurrent));
    if (get(tacticalPlanRuleCurrent)) {
        get(tacticalPlanStore).triggerStartSaveThisRuleByInnerId = get(tacticalPlanRuleCurrent) ?? '';
        tacticalPlanRuleCurrent.set(null);
    }
    get(tacticalPlanStore).triggerZonesSave = true;
    let wait = () => {
        if (get(tacticalPlanStore).triggerStartSaveThisRuleByInnerId!=='') {
            console.log('TacticalPlanRuleOne, waitForZoneSave, wait', get(tacticalPlanStore).triggerStartSaveThisRuleByInnerId);
            setTimeout(wait, 100);
        } else {
            handler();
        }
    };
    wait();
}